import { render, staticRenderFns } from "./EditMatchForBook.vue?vue&type=template&id=f2d8cddc&scoped=true"
import script from "./EditMatchForBook.vue?vue&type=script&lang=js"
export * from "./EditMatchForBook.vue?vue&type=script&lang=js"
import style0 from "./EditMatchForBook.vue?vue&type=style&index=0&id=f2d8cddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8cddc",
  null
  
)

export default component.exports